<script setup lang="ts">
defineOptions({
	name: "admin.teachers",
});
definePage({
	name: "admin.teachers",
	redirect: "/admin/teachers/pending",
	meta: {
		hasKeepAlive: ["admin.schools"],
		permissions: "view-teacher-management",
	},
});
</script>

<template>
	<div class="sup-page">
		<router-view />
	</div>
</template>

<style scoped lang="scss"></style>
